var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Alert, Button, Typography, Drawer, DrawerHeader, } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { Locker, Store } from '@one-thd/sui-icons';
import React, { useEffect, useState } from 'react';
import { getLockerCode } from '../../../api/oms/order-history';
import '../../../styles/order-details.scss';
export var PickupLockerQRCode = function (_a) {
    var _b, _c, _d, _e;
    var buttonVariant = _a.buttonVariant, orderNumber = _a.orderNumber, fulfillmentGroup = _a.fulfillmentGroup, customerType = _a.customerType;
    var _f = useState(false), open = _f[0], setOpen = _f[1];
    var _g = useState(false), hasError = _g[0], setHasError = _g[1];
    var _h = useState(''), lockerCode = _h[0], setLockerCode = _h[1];
    var svocID = useThdCustomer().svocID;
    var thdCustomerCookie = (_e = (_d = (_c = (_b = ('; ' + (document === null || document === void 0 ? void 0 : document.cookie))) === null || _b === void 0 ? void 0 : _b.split("; THD_CUSTOMER=")) === null || _c === void 0 ? void 0 : _c.pop()) === null || _d === void 0 ? void 0 : _d.split(';')) === null || _e === void 0 ? void 0 : _e[0];
    var onClick = function (ev) {
        ev.stopPropagation();
        setOpen(true);
    };
    var handleClose = function () {
        setOpen(false);
    };
    var handleModalClick = function (ev) {
        ev.stopPropagation();
    };
    var lockerPickupEligible = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, response, error_1;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 2, , 3]);
                    request = {
                        lockerCodeRequest: {
                            customerAccountId: svocID !== null && svocID !== void 0 ? svocID : '',
                            orderNumber: orderNumber,
                            storeNumber: (_c = (_b = (_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.storePickup) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.number) !== null && _c !== void 0 ? _c : '',
                        },
                    };
                    return [4 /*yield*/, getLockerCode(request, customerType, "THD_CUSTOMER=".concat(thdCustomerCookie))];
                case 1:
                    response = _g.sent();
                    if (response !== null) {
                        setLockerCode((_f = (_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.lockerAccessCodes) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.accessCode);
                    }
                    return [2 /*return*/, null];
                case 2:
                    error_1 = _g.sent();
                    setHasError(true);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        lockerPickupEligible();
    }, []);
    return (React.createElement("div", null,
        React.createElement("div", { className: "card-fix" },
            React.createElement(Button, { variant: buttonVariant, onClick: onClick }, "View Locker Pickup QR Code")),
        React.createElement(Drawer, { open: open, onClose: function () { return handleClose(); } },
            React.createElement("div", { onClick: handleModalClick, role: "button", tabIndex: 0, onKeyDown: function (ev) {
                    if (ev.key === 'Enter' || ev.key === ' ') {
                        handleModalClick(ev);
                    }
                }, style: { height: hasError ? '345px' : '485px', cursor: 'default' } },
                React.createElement(DrawerHeader, { onClose: handleClose, title: "Pickup Locker QR Code" }),
                React.createElement("div", null,
                    React.createElement("div", { className: "sui-flex sui-flex-col sui-m-auto" },
                        hasError || lockerCode === '' ? (React.createElement("div", { className: "sui-mx-[22.5px]" },
                            React.createElement(Alert, { status: "error" },
                                React.createElement(Typography, { variant: "body-sm" }, "Looks like we had a technical issue. Visit the help desk at your pickup location to retieve your item(s).")))) : (React.createElement("div", { className: "sui-flex sui-flex-col sui-items-center sui-m-auto sui-mb-[5px]" },
                            React.createElement("div", { className: "sui-overflow-hidden" },
                                React.createElement("img", { src: "https://storage.googleapis.com/hd-custcomm-prod-qr-static/".concat(lockerCode, ".png"), alt: "QR Code Pic", style: { transform: 'scale(1.35)' }, width: "230", height: "230" })),
                            React.createElement("div", { className: "sui-flex sui-gap-1 sui-mt-[4px]" },
                                React.createElement(Typography, { variant: "body-sm", color: "subtle", weight: "bold" }, "Locker Code:"),
                                React.createElement(Typography, { variant: "body-sm", color: "subtle", weight: "bold", style: { letterSpacing: '4px' } }, lockerCode)))),
                        React.createElement("div", { className: "sui-flex sui-gap-[10px] sui-mb-[10px] sui-mx-[22.5px]" },
                            React.createElement(Store, { size: "large" }),
                            React.createElement(Typography, { variant: "body-sm" }, "Go to your selected Home Depot store pickup location")),
                        React.createElement("div", { className: "sui-flex sui-gap-[12px] sui-mx-[22.5px]" },
                            React.createElement(Locker, { size: "large" }),
                            React.createElement(Typography, { variant: "body-sm" }, "Scan the QR code at the pickup lockers to retrieve your item(s)."))))))));
};
